module.exports = __webpack_public_path__ + "img/franklin-logo.5be81eed.png";